import { formatBenefitsFootnoteNumber } from "./formatBenefitsFootnoteNumber.js";
const formatBenefitsFootnote = (benefits) => {
  return benefits.reduce((acc, benefit) => {
    const order = formatBenefitsFootnoteNumber(benefits, benefit);
    if (!order || !benefit.description) {
      return acc;
    }
    return [
      ...acc,
      {
        id: benefit.id,
        order,
        text: benefit.description
      }
    ];
  }, []);
};
export {
  formatBenefitsFootnote
};
